import React from 'react';
import InfoTooltip from '../../components/InfoTooltip';

const QUIZ_ENABLED = process.env.REACT_APP_LF_ENABLE_QUIZ === 'true';

function PrimaryActionBar({
  state,
  buttonLabel,
  onNext,
  isAskingQuestion,
  onAskQuestion,
  hasCompletedVideos,
}) {
  const isLoading = ['LOADING', 'LOADING_QNA'].includes(state);
  const showAskButton =
    state !== 'LOADING'
    && ['LOADING_QNA', 'TAKEAWAYS_HIDDEN', 'FIRST_QNA'].includes(state)
    && !isAskingQuestion;

  return (
    <div className="flex mb-3 items-center">
      <button
        className={`${isLoading ? 'bg-gray-400' : 'bg-blue-500'} text-white py-2 px-4 rounded`}
        disabled={isLoading}
        onClick={onNext}
      >
        {buttonLabel}
      </button>
      {showAskButton && (
        <button
          className="ml-2 bg-white border border-blue-500 text-blue-500 py-2 px-4 rounded hover:bg-blue-50 transition-colors"
          onClick={onAskQuestion}
        >
          Ask a question
        </button>
      )}
      {QUIZ_ENABLED && !hasCompletedVideos && (
        <div className="relative ml-2 p-1">
          <InfoTooltip text="Watch the video and pass the quiz to mark as completed" />
        </div>
      )}
    </div>
  );
}

export default PrimaryActionBar;
